import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  withRouterConfig,
  PreloadAllModules,
} from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { Calendar } from '@awesome-cordova-plugins/calendar/ngx';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import {
  provideHttpClient,
  HttpClient,
  withInterceptors,
  HttpInterceptorFn,
  HttpErrorResponse
} from '@angular/common/http';
import { NgxPermissionsModule } from 'ngx-permissions'; // Import NgxPermissionsModule
import { Capacitor } from '@capacitor/core';
import 'add-to-calendar-button';
// import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { getAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';


// 🌍 Translation loader factory
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
if (environment.production) {
  enableProdMode();
}
import { addIcons } from 'ionicons';
import * as allIcons from 'ionicons/icons';

const publicAuthRoutes = [
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/verify-email',
  '/verify-otp',
  '/verify-register-email',
];

function isPublicAuthRoute(url: string): boolean {
  const path = url.split(/[?#]/)[0];
  return publicAuthRoutes.includes(path);
}

function hasPendingAuthResumeRoute(): boolean {
  const route = localStorage.getItem('authResumeRoute');
  return !!route && isPublicAuthRoute(route);
}

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const token = localStorage.getItem('auth_token');

  const authReq = token
    ? req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
        localStorage.removeItem('userId');
        localStorage.removeItem('roles');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userName');

        if (!isPublicAuthRoute(router.url) && !hasPendingAuthResumeRoute()) {
          router.navigate(['/login']);
        }
      }
      return throwError(() => error);
    }),
  );
};
addIcons(allIcons);
bootstrapApplication(AppComponent, {
  providers: [
    Calendar,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({ swipeBackEnabled: true }),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideMessaging(() => getMessaging()),
    provideAnalytics(() => getAnalytics()),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
    ),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      NgxPermissionsModule.forRoot(),
    ),
    provideHttpClient(withInterceptors([jwtInterceptor])),
  ],
}).then(() => {
  // Register service worker for web push
  if (!Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('firebase-messaging-sw.js')
      .then((registration) => {
        console.log('Service Worker registered:', registration);
      })
      .catch((err) => {
        console.error('Service Worker registration failed:', err);
      });
  }
});
